import { render, staticRenderFns } from "./noPersermission.vue?vue&type=template&id=5eefbd6b&scoped=true"
import script from "./noPersermission.vue?vue&type=script&lang=js"
export * from "./noPersermission.vue?vue&type=script&lang=js"
import style0 from "./noPersermission.vue?vue&type=style&index=0&id=5eefbd6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eefbd6b",
  null
  
)

export default component.exports